export function shouldExpandPageElement(elementLayout, pageLayout) {
  return elementLayout.y + elementLayout.height > pageLayout.height;
}
